<template>
  <div>
    <v-alert type="info" variant="tonal" v-if="examGroupInfo">
      Конкурс {{ examGroupInfo.code }} {{ examGroupInfo.name }}
      <span v-if="examGroupInfo.additionalTest[0].is_budget == '1'"
        >(бюджет)</span
      >
      <span v-else>(договор)</span>
      ({{ examGroupInfo.education_name }},{{ examGroupInfo.study_name }}
      <span v-if="examGroupInfo.is_prof == '1'">,профессионалитет</span
      ><span v-if="examGroupInfo.in_group == '1'">,пополнение</span>)
    </v-alert>
    <v-data-table
      v-if="examGroupInfo"
      :headers="headers"
      :items="examGroupInfo.applicants"
      :hide-default-footer="true"
      :items-per-page="-1"
    >
      <template v-slot:body="{ items }">
        <tr v-for="item in items" :key="item.name">
          <td>{{ item.name }}</td>
          <td @click.stop="editItem(item.name)">
            <span v-if="!editedCell || editedCell != item.name">{{
              item.additionalTestResult.result
            }}</span>
            <v-text-field
              class="pointer"
              v-else
              v-model="item.additionalTestResult.result"
              dense
              single-line
              :autofocus="true"
              :rules="rules.numbers"
              @keypress="validateNumber(event)"
              v-on:keyup.enter="saveItemAndClose(item.additionalTestResult)"
              @blur="editedCell = null"
              @change="saveItemAndClose(item.additionalTestResult)"
            >
            </v-text-field>
          </td>
        </tr>
      </template>

      <template v-slot:bottom> </template>
    </v-data-table>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
export default {
  name: "additionalTest",
  data() {
    return {
      rules: {
        numbers: [
          (value) => {
            const pattern = /^[+-]?\d+(\.\d+)?$/;
            return pattern.test(value) || "Только число";
          },
        ],
      },
      editedCell: null,
      examGroupId: 0,
      examGroupInfo: null,
      students: [],
      headers: [
        { title: "ФИО абитуриента", key: "name" },
        { title: "Балл за испытание", key: "result" },
      ],
    };
  },
  created() {
    this.examGroupId = useRoute().params.id;

    this.axios
      .post(
        this.$model.wwwroot +
          "/procollege/manage_groups/admission/additionalTest/AdditionalTestGetList",
        new URLSearchParams({
          id: this.examGroupId,
        })
      )
      .then((response) => {
        this.examGroupInfo = response.data.groups[0];
        let budget =
          this.examGroupInfo.additionalTest[0].is_budget == "1"
            ? "(бюджет)"
            : "(договор)";
        this.$eventBus.$emit("push-crumbs", {
          to: "/admission/additionalTest/" + this.examGroupId,
          title: this.examGroupInfo.additionalTest[0].name + budget,
          disabled: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    validateNumber(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      }
      return true;
    },
    editItem(applicantName) {
      this.editedCell = applicantName;
    },
    saveItemAndClose(resultRecord) {
      if (this.editedCell) {
        this.editedCell = null;
        this.axios
          .post(
            this.$model.wwwroot +
              "/procollege/manage_groups/admission/additionalTest/setApplicantResult",
            new URLSearchParams({
              id: this.examGroupId,
              record: JSON.stringify(resultRecord),
            })
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
